import { forwardRef, useEffect, useState } from "react";
import classNames from "classnames";

import { CFormGroup, CLabel } from "@coreui/react";

import { formatNumberToDisplay } from "src/utils/funcs/numeral";

const allowedKeys = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "Backspace",
  "ArrowUp",
  "ArrowDown",
  "Tab",
  ".",
];

export const CNumberInput = forwardRef(
  (
    {
      label,
      onChange,
      className,
      value,
      min = 0,
      max = 99999999,
      required = false,
      currency = "",
      onEnter,
      onChangeCallback,
      ...rest
    },
    ref
  ) => {
    const [isFocus, setIsFocus] = useState(false);
    const [displayValue, setDisplayValue] = useState(value?.toString() ?? "");

    useEffect(() => {
      if (!isFocus) {
        if (formatNumberToDisplay(value, currency) !== displayValue) {
          setDisplayValue(formatNumberToDisplay(value, currency));
        }
      }
    }, [isFocus, displayValue, value, currency]);

    const _class = classNames("c-input c-number", className);

    const onKeyDown = (event) => {
      if (event.key === "Enter") {
        onEnter?.();
      } else if (
        !allowedKeys.includes(event.key) ||
        (event.key === "." && displayValue?.includes("."))
      ) {
        event.preventDefault();
      }
    };

    const onValueChange = (e) => {
      let tmpValue = e.target.value;
      setDisplayValue(tmpValue);
      onChange?.(Number(tmpValue));
      onChangeCallback?.(Number(tmpValue));
    };

    const onFocus = (event) => {
      setIsFocus(true);
      setDisplayValue((prev) => {
        let result = prev;
        result = result.replaceAll(",", "");
        if (currency) result = result.replaceAll(currency, "");
        return result;
      });
    };

    const onBlur = (event) => {
      setIsFocus(false);
      setDisplayValue(formatNumberToDisplay(value, currency));
    };

    return (
      <CFormGroup className={_class}>
        {label && (
          <CLabel>
            {label} {required && <span className="text-danger">*</span>}
          </CLabel>
        )}
        <input
          ref={ref}
          type="text"
          value={displayValue || 0}
          className="form-control c-number-input"
          onKeyDown={onKeyDown}
          onChange={onValueChange}
          autoSave="off"
          autoComplete="off"
          autoCorrect="off"
          {...rest}
          onFocus={onFocus}
          onBlur={onBlur}
          style={{ textAlign: "inherit" }}
        />
      </CFormGroup>
    );
  }
);
